<template>
  <Icon
    :icon="icon"
    :class="className"
    :width="size"
    :height="size"
    v-bind="$attrs"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Icon } from '@iconify/vue'

interface Props {
  icon: string
  size?: string | number
  class?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: '1em',
  class: ''
})

const className = computed(() => props.class)
</script>